import useInputListController from "../hooks/useInputListController";
import { ActionIcon, Flex } from "@mantine/core";
import CustomInput from "../CustomInput/CustomInput";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import MedHistoryButton from "../_Medical/MedHistory/MedHistoryButton";
import { StyledActionIcon } from "../../styled";
import { memo } from "react";

interface Props {
  id: string;
  list: string[];
  required: boolean;
  history?: boolean;
  dynamicRows: boolean;
  tag?: string;
  renderInput: (id: string, index: number, value: any) => JSX.Element;
}

const InputList = ({
  id,
  list,
  history,
  dynamicRows,
  tag,
  renderInput,
}: Props) => {
  const { fields, handleAdd, handleRemove } = useInputListController({
    list,
    id,
  });
  return (
    <Flex id={id} className={tag} justify="space-between" gap="sm">
      <Flex direction="column" gap="sm" style={{ flex: 1 }}>
        {fields.map((item, index) => (
          <Flex key={item.id} w="100%" gap="sm" align="center">
            {renderInput(id, index, item.text)}
            <ActionIcon color="red" onClick={handleRemove(index)}>
              <IconTrash />
            </ActionIcon>
          </Flex>
        ))}
      </Flex>
      <Flex align="flex-end" gap="sm">
        {history && tag && <MedHistoryButton tag={tag} />}
        {dynamicRows && (
          <StyledActionIcon onClick={handleAdd}>
            <IconPlus />
          </StyledActionIcon>
        )}
      </Flex>
    </Flex>
  );
};
export default memo(InputList);
